import { UrlSearchFilterProperty } from '@/constants';
import { useUrlFilter, useUrlPagination } from '@/hooks';

export const useStockListApiQueryParams = () => {
    const { debouncedSearchText, sortBy, sortOrder, getSearchFilter } =
        useUrlFilter();
    const { page, limit } = useUrlPagination();

    const brandIdFilter = getSearchFilter(UrlSearchFilterProperty.BRAND_ID);

    const queryParams: Record<string, any> = {
        page,
        limit,
        sort_by: sortBy,
        sort_order: sortOrder,
        search: debouncedSearchText,
    };

    if (brandIdFilter) {
        queryParams[UrlSearchFilterProperty.BRAND_ID] = brandIdFilter;
    }

    return queryParams;
};
